import {REGISTRO_EXITOSO, 
    REGISTRO_ERROR,
    OBTENER_USUARIO,
 LOGIN_EXITOSO,
LOGIN_ERROR, 
 CERRAR_SESION} from '../../Types/index';
import React,{useReducer} from 'react';
 import AuthContext from './authContext';
 import AuthReducer from './authReducer';
 import clienteAxios from '../../config/axios';
 import tokenAuth from '../../config/token';

 const AuthState = props =>{
  
    const initialState = {
        token: localStorage.getItem('token'),
        autenticado: null,
        usuario: null,
        mensaje: null,
        cargando: true
    }

    const [state, dispatch] = useReducer (AuthReducer, initialState);

const registrarUsuario = async datos =>{
    try {
        const respuesta = await clienteAxios.post('/api/usuarios', datos);
       // console.log(respuesta.data);
        dispatch({
            type:REGISTRO_EXITOSO,
            payload: respuesta.data
        })
        //Obtener usuario
        usuarioAutenticado();
    } catch (error) {
       // console.log(error.response);
        const alerta = {
            msg: error.response.data.msg,
            categoria: 'alerta-error'
        }
        dispatch({
            type: REGISTRO_ERROR,
            payload: alerta
        })
    }
}
    //retorna el usuario autenticado
    const usuarioAutenticado = async () =>{
        const token = localStorage.getItem('token');
        if(token){
            //funcion para enviar el token por headers
            tokenAuth(token);
        }
        try {
            const respuesta = await clienteAxios.get('/api/auth');
           // console.log(respuesta.data);
            dispatch({
                type: OBTENER_USUARIO,
                payload: respuesta.data.usuario.nombre
            });
        } catch (error) {
            console.log(error.response);
            dispatch({
                type: LOGIN_ERROR
            })
        }
    }

    const iniciarSesion = async datos =>{
        try {
            const respuesta = await clienteAxios.post('/api/auth', datos);
          //  console.log(respuesta.data);
            dispatch({
                type:LOGIN_EXITOSO,
                payload: respuesta.data
            })
            //obtener el usuario
            usuarioAutenticado();
        } catch (error) {
           // console.log(error.response.data);
             const alerta = {
                 msg: error.response.data.msg,
                 categoria: 'alerta-error'
             }
             dispatch({
                 type: LOGIN_ERROR,
                 payload: alerta
             })
            }
    }
    //cerrar sesion
    const cerrarSesion = () =>{
        dispatch({
            type:CERRAR_SESION
        })
    }

    return (

        <AuthContext.Provider value={{
            cargando: state.cargando,
            token: state.token,
            autenticado: state.autenticado,
            usuario: state.usuario,
            mensaje: state.mensaje,
            registrarUsuario,
            usuarioAutenticado,
            iniciarSesion,
            cerrarSesion
        }}>
            {props.children}
        </AuthContext.Provider>

    )
 }
 export default AuthState;